module.exports = __webpack_public_path__ + "img/info-03.48b4c506.jpg";